import React from 'react';
import WebLayout from '../layouts/WebLayout';
import Privacy from '../../../common/Privacy';

const PrivacyPage = () => {
    return (
        <WebLayout>
            <div className="min-h-screen">
                {/* 개인정보처리방침 페이지 본문 내용이 여기에 들어갑니다 */}
                <Privacy />
            </div>
        </WebLayout>
    );
};

export default PrivacyPage;
